import { ApplicationsAPI } from "api/api/applicationsApi/applicationsApi";
import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import { PostApplicationsMarathonUnmarkParams, PostApplicationsMarathonUnmarkResponse } from "api/api/applicationsApi/types";

export const postApplicationsMarathonUnmark = createAsyncThunk<
  PostApplicationsMarathonUnmarkResponse,
  PostApplicationsMarathonUnmarkParams
>(
  `applications/postApplicationsMarathonUnmark`,
  async ({ marathonId, ...params }, { rejectWithValue }) => {
    try {
      const data = await ApplicationsAPI.postApplicationsMarathonUnmark({
        marathonId,
        ...params,
      });
      return data;
    } catch (error: unknown) {
      if (axios.isAxiosError(error)) {
        console.error(
          "Error while posting applications marathon unmark",
          error?.response?.data
        );
        return rejectWithValue(error?.response?.data || "Unknown error");
      } else {
        console.error(
          "Error while posting applications marathon unmark",
          error
        );
        return rejectWithValue(
          "Что-то пошло не так... Попробуйте обновить страницу"
        );
      }
    }
  }
);
